import React from 'react';
import GuideStep from 'components/InstallationGuide/GuideStep';
import GuideHeading from 'components/InstallationGuide/GuideHeading';
import GuideParagraph from 'components/InstallationGuide/GuideParagraph';
import CopyableCodeSnippet from 'components/Common/CopyableCodeSnippet';

const InstallScript = props => {
  const { accountId, moveForward, moveBackward, stepMax, stepIndex } = props;

  return (
    <GuideStep
      stepIndex={stepIndex}
      stepMax={stepMax}
      title="Add the Appcues script"
      moveForward={moveForward}
      moveBackward={moveBackward}
    >
      <GuideHeading>WHY</GuideHeading>
      <GuideParagraph>
        The script allows Appcues to show content to your end users.
      </GuideParagraph>
      <GuideHeading>HOW</GuideHeading>
      <GuideParagraph>
        Copy the snippet and paste it as the first item in your{' '}
        <code className="language-markup">{`<head>`}</code> section on every
        page you want to use Appcues.
      </GuideParagraph>
      <CopyableCodeSnippet language="markup">
        {`<script type="text/javascript">
  window.AppcuesSettings = {
    enableURLDetection: true
  };
</script>
<script src="//fast.appcues.com/${accountId}.js"></script>`}
      </CopyableCodeSnippet>
      <GuideParagraph isLastParagraph>
        The file name should be your account ID, which is{' '}
        <strong>{accountId}</strong>.
      </GuideParagraph>
    </GuideStep>
  );
};

export default InstallScript;
